<template>
  <vx-card title="Cumplimiento de ANS">
    <p class="gw-bajada">
      Porcentaje de procesos resueltos dentro del plazo acordado durante el
      periodo seleccionado. Un proceso se considera fuera de plazo si alguna de
      sus validaciones lo está.
    </p>

    <div class="gw-kpi-row">
      <div class="gw-kpi">
        <div class="gw-kpi-valor">
          {{ resumen.porcentaje_cumplimiento }}%
        </div>
        <div class="gw-kpi-pie">
          de tus procesos dentro del plazo
        </div>
      </div>

      <div class="gw-kpi-detalle">
        <div><b>{{ resumen.total }}</b> procesos en el periodo</div>
        <div><b>{{ resumen.dentro_de_ans }}</b> dentro de plazo</div>
        <div><b>{{ resumen.fuera_de_ans }}</b> fuera de plazo</div>
        <div class="gw-kpi-curso">{{ resumen.en_curso }} todavía en curso</div>
      </div>
    </div>

    <apexcharts
      v-if="hayTendencia"
      type="line"
      height="260"
      :options="opciones"
      :series="series"
    />
    <p v-else class="gw-sin-tendencia">
      La evolución semanal se muestra a partir de la segunda semana con
      procesos medidos.
    </p>
  </vx-card>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import slaFormat from "../../mixins/slaFormat";

export default {
  name: "SlaComplianceKpi",
  mixins: [slaFormat],
  components: { apexcharts: VueApexCharts },
  props: {
    resumen: { type: Object, required: true },
    tendencia: { type: Array, default: () => [] },
    meta: { type: Number, default: 65 },
  },

  computed: {
    hayTendencia() {
      return this.tendencia.length >= 2;
    },

    series() {
      return [
        {
          name: "Cumplimiento",
          data: this.tendencia.map((s) => s.porcentaje_cumplimiento),
        },
      ];
    },

    opciones() {
      return {
        chart: { type: "line", toolbar: { show: false }, zoom: { enabled: false } },
        colors: [this.GW_MORADO],
        stroke: { width: 3, curve: "straight" },
        markers: { size: 4 },
        dataLabels: { enabled: false },
        grid: { borderColor: "#eee" },
        xaxis: {
          categories: this.tendencia.map((s) => this.semanaCorta(s.semana)),
          labels: { style: { colors: this.GW_GRIS_SUAVE, fontSize: "11px" } },
          axisBorder: { show: false },
          axisTicks: { show: false },
        },
        yaxis: {
          min: 0,
          max: 100,
          tickAmount: 4,
          labels: {
            style: { colors: this.GW_GRIS_SUAVE, fontSize: "11px" },
            formatter: (v) => Math.round(v) + "%",
          },
        },
        // La meta va como línea de referencia y no como segunda serie: es un
        // umbral, no una medición, y dibujarla como serie invita a compararlas
        // como si fueran dos cosas del mismo tipo.
        annotations: {
          yaxis: [
            {
              y: this.meta,
              borderColor: "#c9c9c9",
              strokeDashArray: 4,
              label: {
                text: "Meta " + this.meta + "%",
                style: { color: this.GW_GRIS, background: "#f3f3f3", fontSize: "11px" },
              },
            },
          ],
        },
        tooltip: {
          y: { formatter: (v) => v + "% dentro de plazo" },
        },
      };
    },
  },

  methods: {
    semanaCorta(iso) {
      if (!iso) return "";
      const p = String(iso).slice(0, 10).split("-");
      return p.length === 3 ? p[2] + "/" + p[1] : String(iso);
    },
  },
};
</script>

<style scoped>
.gw-bajada {
  font-size: 12px;
  color: #9a9a9a;
  margin: -6px 0 18px;
  max-width: 76ch;
  line-height: 1.5;
}
.gw-kpi-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 32px;
  margin-bottom: 18px;
}
/* El numero va siempre en el color de marca. Antes se ponia rojo al bajar de
   la meta, y sin el texto que explicaba la meta ese rojo no decia nada. La
   comparacion contra el 65% vive en la linea de referencia de la grafica. */
.gw-kpi-valor {
  font-size: 46px;
  line-height: 1;
  font-weight: 700;
  color: #5f0091;
}
.gw-kpi-pie {
  font-size: 13px;
  color: #6b6b6b;
  margin-top: 6px;
}
.gw-kpi-detalle {
  font-size: 13px;
  color: #6b6b6b;
  line-height: 1.7;
}
.gw-kpi-detalle b {
  color: #3b3b3b;
}
.gw-kpi-curso {
  color: #9a9a9a;
  font-size: 12px;
}
.gw-sin-tendencia {
  font-size: 12px;
  color: #9a9a9a;
  margin: 18px 0 4px;
}
</style>
